import React, { useEffect } from "react";
import { Col, Container, Row } from "@themesberg/react-bootstrap";
import Input from "./Input";

export default () => {
  useEffect(() => {
    document.title = "Nhập vé";
  }, []);

  return (
    <Container fluid>
      <Row>
        <Col>
          <Input />
        </Col>
      </Row>
    </Container>
  );
};
